import { Injectable } from '@angular/core';
import { BoSpinnerService, BoToastrService } from 'src/@core/shared';
import { AdditionalDrop } from 'src/@core/models';
import { HttpClient } from '@angular/common/http';
import { API } from '../config/api';
import { tap, catchError } from 'rxjs/operators';
import { SUCCESS } from 'src/@shared/constants';
import { ErrorResponse } from '../config/common';
import { CreateAdditionalDropsRequest } from '.';

@Injectable()
export class AdditionalDropsService {

    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService,
        private _toastr: BoToastrService
    ) {

    }
    // LAY TAT CA
    public GetAll_AdditionalDrops() {
        this._spinner.show(true);
        return this._http.get<AdditionalDrop[]>(`${API.ADDITIONAL_DROPS.GETALL}`)
            .pipe(tap(() => this._spinner.hide()));
    }

    // LAY TAT CA ADDITIONDROPS CU 1 CONSIGMENT
    public GetAll_AdditionalDrops_Condigment(IdConsigment: string) {
        this._spinner.show(true);
        return this._http.get<AdditionalDrop[]>(`${API.ADDITIONAL_DROPS.GETALL_BY_CONSIGMENT(IdConsigment)}`)
            .pipe(tap(() => this._spinner.hide()));
    }

    // LAY MOT AdditionalDrops
    public GetOne_AdditionalDrops(id: string) {
        this._spinner.show(true);
        return this._http.get<AdditionalDrop>(`${API.ADDITIONAL_DROPS.GETONE(id)}`)
            .pipe(tap(() => this._spinner.hide()));
    }

    // THEM
    public Add_AdditionalDrops(body: CreateAdditionalDropsRequest) {


        if(body['consignmentPallets'].length > 0){
            for(let i = 0 ; i< body['consignmentPallets'].length; i++){
                delete body['consignmentPallets'][i]['additionalDropID'];
            }
        }
        if(body['consignmentPackages'].length > 0){
            for(let i = 0 ; i< body['consignmentPackages'].length; i++){
                delete body['consignmentPackages'][i]['additionalDropID'];
            }
        }

        // NEU MANG RONG THI DE NULL
        body['consignmentPackages'] = (body['consignmentPackages'].length == 0 || body['consignmentPackages'] == null) ? null : body['consignmentPackages'];
        body['consignmentPallets'] = (body['consignmentPallets'].length == 0 || body['consignmentPallets'] == null) ? null : body['consignmentPallets'];
        for (var propName in body) {
            if (body[propName] == "") {
              delete body[propName];
            }
          }

        return this._http.post(`${API.ADDITIONAL_DROPS.ADD}`, body)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.CREATE_ADDITIONALDROPS);
                }),
                catchError((err: ErrorResponse) => {
                    if (err && err.error && err.error.errors) {
                        err.error.errors.map(m => {
                            this._toastr.error(m)
                        });
                    }
                    throw err;
                })
            );
    }

    // CHINH SUA
    public Edit_AdditionalDrops(id: string, body: AdditionalDrop) {

        // NEU MANG RONG THI DE NULL
        body['consignmentPackages'] = (body['consignmentPackages'].length == 0 || body['consignmentPackages'] == null) ? null : body['consignmentPackages'];
        body['consignmentPallets'] = (body['consignmentPallets'].length == 0 || body['consignmentPallets'] == null) ? null : body['consignmentPallets'];

        return this._http.put(API.ADDITIONAL_DROPS.EDIT(id), body)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.EDIT_ADDITIONALDROPS);
                }),
                catchError((err: ErrorResponse) => {
                    if (err && err.error && err.error.errors) {
                        err.error.errors.map(m => {
                            this._toastr.error(m)
                        });
                    }
                    throw err;
                })
            )
    }

  // XOA
  public Delete_AdditionalDrops(id: string) {
    return this._http.delete(API.ADDITIONAL_DROPS.DELETE(id))
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.DELETE_ADDITIONALDROPS);
        }),
        catchError((err: ErrorResponse) => {
          if (err && err.error && err.error.errors) {
            err.error.errors.map(m => {
              this._toastr.error(m)
            });
          }
          throw err;
        })
      )
  }

  public GetAll_OrderAdditionalDrops() {
    this._spinner.show(true);
    return this._http.get<AdditionalDrop[]>(`${API.ORDER_ADDITIONAL_DROPS.GETALL}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  // LAY TAT CA ADDITIONDROPS CU 1 CONSIGMENT
  public GetAll_OrderAdditionalDrops_Consignment(IdConsigment: string) {
    this._spinner.show(true);
    return this._http.get<AdditionalDrop[]>(`${API.ORDER_ADDITIONAL_DROPS.GETALL_BY_ORDERTEMPLATE(IdConsigment)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  // LAY MOT AdditionalDrops
  public GetOne_OrderAdditionalDrops(id: string) {
    this._spinner.show(true);
    return this._http.get<AdditionalDrop>(`${API.ORDER_ADDITIONAL_DROPS.GETONE(id)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  public Add_OrderAdditionalDrops(body: CreateAdditionalDropsRequest) {
      return this._http.post(`${API.ORDER_ADDITIONAL_DROPS.ADD}`, body)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.CREATE_ADDITIONALDROPS);
        }),
        catchError((err: ErrorResponse) => {
          if (err && err.error && err.error.errors) {
            err.error.errors.map(m => {
              this._toastr.error(m)
            });
          }
          throw err;
        })
      );
  }

  public Edit_OrderAdditionalDrops(id: string, body: AdditionalDrop) {

   
    return this._http.put(API.ORDER_ADDITIONAL_DROPS.EDIT(id), body)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.EDIT_ADDITIONALDROPS);
        }),
        catchError((err: ErrorResponse) => {
          if (err && err.error && err.error.errors) {
            err.error.errors.map(m => {
              this._toastr.error(m)
            });
          }
          throw err;
        })
      )
  }

  // XOA
  public Delete_OrderAdditionalDrops(id: string) {
    return this._http.delete(API.ORDER_ADDITIONAL_DROPS.DELETE(id))
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.DELETE_ADDITIONALDROPS);
        }),
        catchError((err: ErrorResponse) => {
          if (err && err.error && err.error.errors) {
            err.error.errors.map(m => {
              this._toastr.error(m)
            });
          }
          throw err;
        })
      )
  }  
}
